import { Toaster as Sonner, toast } from "sonner"

const WhistleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8.5C2 8.5 4 6 7 6C8.5 6 10 6.5 11 7.5L18.5 3L20 5L13 10C13.6 11 14 12.2 14 13.5C14 17.1 11.1 20 7.5 20C3.9 20 1 17.1 1 13.5C1 11.5 1.5 9.8 2 8.5Z" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="#10b981" fillOpacity="0.2"/>
    <circle cx="7" cy="14" r="2" fill="#10b981"/>
    <path d="M18.5 3L21 4" stroke="#10b981" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

const RedCardIcon = () => (
  <div style={{
    width: 16,
    height: 22,
    backgroundColor: '#ef4444',
    borderRadius: 3,
    boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
    flexShrink: 0,
  }} />
)

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      position="top-center"
      className="toaster group"
      icons={{
        success: <WhistleIcon />,
        error: <RedCardIcon />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-gray-900 !text-white !border-gray-700/50 !shadow-2xl !rounded-xl !px-4 !py-3 !backdrop-blur-sm !max-w-sm",
          description: "!text-gray-400",
          actionButton:
            "!bg-emerald-600 !text-white !rounded-lg",
          cancelButton:
            "!bg-gray-800 !text-gray-300 !rounded-lg",
          success:
            "!bg-gray-900 !border-emerald-500/30",
          error:
            "!bg-gray-900 !border-red-500/30",
        },
        style: {
          '--toast-bg': '#111827',
          '--toast-border': 'rgba(55, 65, 81, 0.5)',
          '--toast-text': '#f9fafb',
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
